import {getFirstChild} from '../../../utils/dom';

import type {IBannerData} from './IBannerData';
import {BannerSource, type IRbJson} from './IRbJson';

const DIRECT_NODE_ATTR_NAME = 'data-banner-dom-node';

export class BannerDataText implements IBannerData {
    bannerSource: BannerSource | undefined;
    rbJson: IRbJson | undefined;
    text: string;

    constructor(text: string) {
        this.text = text;
        this.rbJson = this.extractRbJson(text);
        if (this.rbJson) {
            this.bannerSource = this.rbJson[0].source;
        }
    }

    checkBannerFallback(): boolean {
        const rbJson = this.rbJson?.[0];
        if (!rbJson || !rbJson.nodeId || !rbJson.source || !rbJson.fallback || !rbJson.fallback.length) {
            return false;
        }
        const fallbackJson = rbJson.fallback[0];
        if (!fallbackJson.nodeId || !fallbackJson.source) {
            return false;
        }
        const startElement = document.getElementById(rbJson.nodeId);
        const fallbackElement = document.getElementById(fallbackJson.nodeId);
        if (startElement && fallbackElement
                && (startElement.offsetHeight <= 0 || startElement.offsetLeft < 0 || !startElement.firstChild)
                && (fallbackElement.offsetHeight > 0)) {
            this.bannerSource = fallbackJson.source;
            return true;
        }
        return false;
    }

    extractRbJson(text: string): IRbJson | undefined {
        if (!text) {
            return;
        }
        const jsonPrefix = '<!--RB-JSON:[';
        const start = text.indexOf(jsonPrefix);
        if (start < 0) {
            return;
        }
        const end = text.indexOf(']-->', start + jsonPrefix.length);
        if (end < 0) {
            return;
        }
        const jsonText = text.substring(start + jsonPrefix.length - 1, end + 1);
        if (jsonText) {
            let rbJson;
            try {
                rbJson = JSON.parse(jsonText);
            } catch (e) {
                // No op
            }
            if (Array.isArray(rbJson) && rbJson.length) {
                return rbJson;
            }
        }
    }

    getUsedDirectBannerNode() {
        const rbJson = this.rbJson?.[0];
        // Баннер от Яндекса может встраиваться не в наш контейнер, а в конец страницы.
        // Пытаемся его найти. Если нашли, будем считать, что реклама отображается.
        if (rbJson && rbJson.source === BannerSource.direct && rbJson.nodeId) {
            const idMatch = rbJson.nodeId.match(/[A-Za-z_\-]+(\d{4,}(?:[\d\-]+)?)/);
            if (idMatch) {
                const bannerNodeList = document.querySelectorAll(`[${DIRECT_NODE_ATTR_NAME}]`);
                for (let i = 0, len = bannerNodeList.length; i < len; i++) {
                    const bannerNode = bannerNodeList[i];
                    const attrValue = bannerNode.getAttribute(DIRECT_NODE_ATTR_NAME);
                    // Нужный элемент может быть вставлен на страницу, но может оказаться пустым.
                    // Если реклама отображается, то внутри дочернего элемента будет ещё один.
                    if (attrValue && attrValue.includes(idMatch[1])
                            && getFirstChild(getFirstChild(bannerNode))) {
                        return bannerNode;
                    }
                }
            }
        }
    }
}
